const SEGMENT_PARAM_KEY = 'segment';
const TRIM_PARAM_KEY = 'trim';
const COMPARE_PARAM_KEY = 'compare';
const SELECTED_TRIMS_COMPARE_COOKIE_NAME = 'SelectedTrimsCompare';

export {
  SEGMENT_PARAM_KEY,
  TRIM_PARAM_KEY,
  COMPARE_PARAM_KEY,
  SELECTED_TRIMS_COMPARE_COOKIE_NAME,
};
